import Head from 'next/head'
import Link from 'next/link'

import { siteConfig } from '@bww/beke-lib/site-config'

export default function TradeContractPage() {
  return (
    <>
      <Head>
        <title>Trade &amp; Contract Bathrooms</title>
      </Head>
      <div className="pageContainer">
        <h1 className="h1">Trade &amp; Contract Enquiries</h1>
        <p>
          Bathroom Elegance provide a professional service for developers,
          builders, interior designers, and architects.
        </p>
        <p>
          With decades of experience working alongside these professionals, we
          understand the right bathrooms and kitchens for your project.
        </p>
        <p>
          Our team are highly experienced with designing and supplying bathrooms
          to the trade; for projects ranging in size from single new build
          properties to sites of multiple plots. We are well versed at working
          alongside site agents and project managers to ensure that the project
          runs smoothly.
        </p>
        <p>
          If you wish to discuss your project with one of our team, then please
          use our <Link href="/contact"> contact form</Link> or give us a call
          on {siteConfig.tel}.
        </p>
      </div>
    </>
  )
}
